// product-fixes.js — Performance patches for variant switching
// Uses AbortController to cancel stale fetches (no debounce timer needed)
// and defers pickup availability by 1 second
(function() {
  var VariantSelects = customElements.get('variant-selects');
  if (!VariantSelects) return;

  var proto = VariantSelects.prototype;

  // 1. Patch renderProductInfo with AbortController
  //    Each call aborts any in-flight fetch, so only the latest completes.
  //    No setTimeout debounce — AbortController handles rapid switching.
  proto.renderProductInfo = function() {
    var self = this;
    var sections = this.getSectionsToRender();

    // Abort any in-flight fetch
    if (this._abortController) this._abortController.abort();
    this._abortController = new AbortController();

    fetch(this.dataset.url + '?variant=' + this.currentVariant.id + '&section_id=' + this.dataset.section, {
      signal: this._abortController.signal
    })
      .then(function(response) { return response.text(); })
      .then(function(responseText) {
        var html = new DOMParser().parseFromString(responseText, 'text/html');
        sections.forEach(function(id) {
          var destination = document.getElementById(id);
          var source = html.getElementById(id);
          if (source && destination) destination.innerHTML = source.innerHTML;

          var price = document.getElementById(id);
          var pricefixed = document.getElementById(id + '--sticky');
          if (price) price.classList.remove('visibility-hidden');
          if (pricefixed) pricefixed.classList.remove('visibility-hidden');
        });
        self.toggleAddButton(!self.currentVariant.available, window.theme.variantStrings.soldOut);
      })
      .catch(function(e) {
        if (e.name === 'AbortError') return;
      });
  };

  // 2. Patch updatePickupAvailability to defer fetch by 1s
  proto.updatePickupAvailability = function() {
    var pickUpAvailability = document.querySelector('.pickup-availability-wrapper');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      if (this._pickupTimer) clearTimeout(this._pickupTimer);
      var self = this;
      this._pickupTimer = setTimeout(function() {
        pickUpAvailability.fetchAvailability(self.currentVariant.id);
      }, 1000);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  };
})();

// 3. Hide Klaviyo's auto-injected BIS button (we have our own custom one)
(function() {
  function hideKlaviyoBIS() {
    document.querySelectorAll('button, a').forEach(function(el) {
      var text = el.textContent.trim().toLowerCase();
      if (text === 'notify me when back in stock' && !el.classList.contains('wickii-bis-trigger')) {
        el.style.display = 'none';
        // Also hide parent wrapper if it's a Klaviyo container
        var parent = el.parentElement;
        if (parent && !parent.classList.contains('wickii-bis-wrapper')) {
          parent.style.display = 'none';
        }
      }
    });
  }
  // Run on load and observe for Klaviyo's late injection
  hideKlaviyoBIS();
  var observer = new MutationObserver(hideKlaviyoBIS);
  observer.observe(document.body, { childList: true, subtree: true });
  // Stop observing after 10s to avoid performance overhead
  setTimeout(function() { observer.disconnect(); }, 10000);
})();
